<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <form role="form" v-on:submit="search">
        <div class="search row">
          <div class="dropdown"></div>
          <div class="col-lg-4 pt-0 pl-0 pr-2">
            <base-input
              alternative=""
              label=""
              placeholder="ข้อมูลที่ต้องการค้นหา"
              input-classes="form-control-alternative"
              v-model="keyword"
            />
          </div>
          <input
            type="submit"
            class="btn btn-primary mt--2 mt-md-0 mb-md-4"
            value="ค้นหาข้อมูล"
          />
        </div>
      </form>
      <div class="row">
        <div class="col">
          <receipt-table
            title="ใบเสร็จ"
            ref="receipts_table"
            :receipts.sync="receipts"
            :total.sync="paginate.total"
            :page.sync="paginate.page"
          ></receipt-table>
          <base-pagination
            :total="paginate.total"
            :perPage="paginate.perPage"
            class="mt-2 d-flex justify-content-end"
            v-model="paginate.page"
          ></base-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ReceiptTable from "./Tables/ReceiptTable";
import kickMixin from "../mixins/kickMixin";

export default {
  name: "receipt",
  mixins: [kickMixin],
  components: {
    ReceiptTable,
  },
  data() {
    return {
      keyword: "",
      receipts: [],
      paginate: {
        total: 0,
        page: 1,
        perPage: 30,
      },
    };
  },
  methods: {
    search: async function(e) {
      e.preventDefault();
      this.$refs.receipts_table.search(this.keyword);
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    }
  },
};
</script>
<style>
.search {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
a {
  cursor: pointer;
}
</style>
